export const isPwContext = (): boolean => window.location.pathname.startsWith('/pw/');

export const getPathPrefix = (): string => (isPwContext() ? '/pw' : '');

export const addPwPrefixToUrl = (url: string): string => {
  if (!url || !isPwContext()) return url;

  try {
    const urlObj = new URL(url);
    if (urlObj.pathname.startsWith('/pw/') || urlObj.hostname !== window.location.hostname) {
      return url;
    }

    urlObj.pathname = `/pw${urlObj.pathname}`;
    return urlObj.toString();
  } catch {
    return url;
  }
};

export const addPwPrefixToBaseUrl = (baseUrl: string): string => (isPwContext() ? `/pw${baseUrl}` : baseUrl);

export const getIconUrl = (url: string | undefined): string | undefined => {
  if (url && url.startsWith('/') && isPwContext()) return `/pw${url}`;
  return url;
};
